import styled from 'styled-components';

const InputErrorMessage = styled.div`
	color: red;
	font-size: 13px;
`;

export default InputErrorMessage;
